import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { isEmpty } from 'lodash';
import ComponentCard from '../../common/components/cards/ComponentCard';
import DealersSelectField from '../forms/DealersSelectField';
import { createBlacklistDealer, searchBlacklistDealers } from '../DealersActions';

const initialValues = {
  dealer: '',
};

function DealerBlacklistForm({ searchParams, dealers }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [currentDealerOption, setCurrentDealerOption] = useState('');
  const [addButtonDisabled, setAddButtonDisabled] = useState(false);
  const [items, setItems] = useState(dealers);

  useEffect(() => {
    setItems(dealers);
  }, [dealers]);

  useEffect(() => {
    const dealersIds = items.map((dealer) => dealer?.blockedOrganization?.id);
    if (
      (isEmpty(dealersIds) && !currentDealerOption) ||
      dealersIds.includes(currentDealerOption?.value)
    ) {
      return setAddButtonDisabled(true);
    }
    return setAddButtonDisabled(false);
  }, [items, currentDealerOption]);

  const handleSubmit = async (values, { setSubmitting, setFieldValue }) => {
    setSubmitting(true);
    await dispatch(
      createBlacklistDealer(id, values?.dealer?.value, () =>
        dispatch(searchBlacklistDealers(searchParams, id)),
      ),
    );
    setFieldValue('dealer', '');
    setSubmitting(false);
  };
  const onChangeHandler = (option) => {
    setCurrentDealerOption(option);
  };
  return (
    <Col md="12">
      <ComponentCard title="Blacklist" isCollapsible>
        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
          {() => (
            <Form autoComplete="off">
              <Row>
                <Col md="4">
                  <DealersSelectField
                    name="dealer"
                    label="Add Dealer"
                    onChangeHandler={onChangeHandler}
                  />
                </Col>
                <Col md="4">
                  <Button
                    className="mt-4 rounded-pill btn-primary"
                    disabled={!currentDealerOption || addButtonDisabled}
                    type="submit"
                  >
                    Add
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </ComponentCard>
    </Col>
  );
}

export default DealerBlacklistForm;
